exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error[data-v-97b4d1dc]{border:1px solid red}", ""]);

// exports
